import { defineComponent as t, openBlock as r, createBlock as l, unref as a, mergeProps as m, withCtx as i, createElementVNode as d } from "vue";
import { RevIcon as p } from "@ds/components/Icon";
const f = /* @__PURE__ */ t({
  name: "IconCommentPendingFilled",
  __name: "IconCommentPendingFilled",
  props: {
    size: {},
    alternativeText: {}
  },
  setup(n) {
    const o = n;
    return (c, e) => (r(), l(a(p), m(o, { "view-box": "0 0 24 24" }), {
      default: i(() => [...e[0] || (e[0] = [
        d("path", {
          "fill-rule": "evenodd",
          d: "M18.5 2.25a3.25 3.25 0 0 1 3.25 3.25v9a3.25 3.25 0 0 1-3.25 3.25h-6.237l-4.794 3.836A.75.75 0 0 1 6.25 21v-3.25H5.5a3.25 3.25 0 0 1-3.25-3.25v-9A3.25 3.25 0 0 1 5.5 2.25h13M7.75 8.75a1.25 1.25 0 1 0 0 2.5 1.25 1.25 0 0 0 0-2.5m4.25 0a1.25 1.25 0 1 0 0 2.5 1.25 1.25 0 0 0 0-2.5m4.25 0a1.25 1.25 0 1 0 0 2.5 1.25 1.25 0 0 0 0-2.5",
          "clip-rule": "evenodd"
        }, null, -1)
      ])]),
      _: 1
    }, 16));
  }
});
export {
  f as default
};
